import PageContent from "./PageContent";

function StudentLayout({ children, loading = false }) {
    return <PageContent loading={loading}>{children}</PageContent>;
}

export default StudentLayout;
